var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkAsUnpaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10.875C5.08095 10.8752 4.18057 10.6155 3.40271 10.126C2.62486 9.63655 2.00121 8.93715 1.60371 8.10851C1.2062 7.27987 1.05103 6.35574 1.1561 5.44271C1.26116 4.52968 1.62217 3.66495 2.1975 2.94825L9.05175 9.80175C8.1872 10.498 7.11006 10.8768 6 10.875ZM9.84225 9.0015C10.5751 8.06374 10.9396 6.8903 10.867 5.70237C10.7944 4.51445 10.2897 3.39411 9.44819 2.55256C8.60664 1.711 7.4863 1.20636 6.29838 1.13378C5.11045 1.06119 3.93701 1.42567 2.99925 2.1585L9.84225 9.0015ZM0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsUnpaid);
export default __webpack_public_path__ + "static/media/mark-as-unpaid.d5f2c459de20a4654ec52480b3405e48.svg";
export { ForwardRef as ReactComponent };